import React from 'react'
import TablePagination from '@material-ui/core/TablePagination'
import { useTheme } from '@material-ui/core'

export interface ProspectsTableFooterProps {
    count: number
    page: number
    rowsPerPage: number
    onChangePage: (
        event: React.MouseEvent<HTMLButtonElement> | null,
        newPage: number,
    ) => void
    onChangeRowsPerPage: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export const ProspectsTableFooter: React.FC<ProspectsTableFooterProps> = ({
    count,
    page,
    rowsPerPage,
    onChangePage,
    onChangeRowsPerPage,
}) => {
    const theme = useTheme()

    return (
        <TablePagination
            component="div"
            rowsPerPageOptions={[5, 10, 25]}
            count={count}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={onChangePage}
            onChangeRowsPerPage={onChangeRowsPerPage}
            style={{
                flexShrink: 0,
                borderTop: `1px solid ${theme.palette.divider}`,
                backgroundColor: theme.palette.background.paper,
            }}
        />
    )
}
